// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import ModalController from "./modal_controller"
import MobileMenuController from "./mobile_menu_controller"
import QuoteWizardController from "./quote_wizard_controller"
import CalendarController from "./calendar_controller"
import SignaturePadController from "./signature_pad_controller"
import SignatureTabsController from "./signature_tabs_controller"
import StatusToggleController from "./status_toggle_controller"

application.register("hello", HelloController)
application.register("modal", ModalController)
application.register("mobile-menu", MobileMenuController)
application.register("quote-wizard", QuoteWizardController)
application.register("calendar", CalendarController)
application.register("signature-pad", SignaturePadController)
application.register("signature-tabs", SignatureTabsController)
application.register("status-toggle", StatusToggleController)
